import { z } from 'zod';

import { zodDecoder } from '$lib/services/api/zod_decoder';
import { mapFromRecord } from '$types/schemas';

const hidableAuditPageSchema = z.enum([
  'MoneyLaundering',
  'TransactionAnalysis',
  'RiskHandlingNotes',
  'ManagementNotes',
]);
type HidableAuditPage = z.infer<typeof hidableAuditPageSchema>;

const visibilitySchema = z.enum(['Hide', 'Show']);
type Visibility = z.infer<typeof visibilitySchema>;

const visibilityByPageSchema = mapFromRecord(hidableAuditPageSchema, visibilitySchema);

const employerSettingsSchema = z.object({
  visibility: visibilityByPageSchema,
});
type EmployerSettings = z.infer<typeof employerSettingsSchema>;

const employerSettingsDecoder = zodDecoder(employerSettingsSchema);

export { employerSettingsDecoder, visibilityByPageSchema };
export type { EmployerSettings, HidableAuditPage, Visibility };
